import type { RunState, Walker } from '../../game/RunState';

/** Seconds for a boarder to walk from the crowd to the door. */
export const WALK_TO_DOOR = 1.1;
/** Seconds an alighter takes to step down and clear the door. */
export const STEP_OFF = 0.6;
/** Alighters stay visible this long while they walk away. */
export const WALK_AWAY = 3;
/** Gap between people stepping on or off. */
export const STEP_INTERVAL = 0.5;

let nextId = 1;

export function startWalker(state: RunState, kind: Walker['kind'], fromSlot: number): Walker {
  const walker: Walker = { id: nextId++, kind, t: 0, fromSlot, s: state.bus.s };
  state.walkers.push(walker);
  return walker;
}

export function boardersWalking(state: RunState): number {
  return state.walkers.filter((w) => w.kind === 'board').length;
}

/** True while someone is still getting on or off, so the bus should wait. */
export function stopIsBusy(state: RunState): boolean {
  const { stop, passengers, bus } = state;
  if (!stop.stopped) return false;
  const seatsLeft = bus.capacity - passengers.length - boardersWalking(state);
  if (stop.alightQueue.length > 0) return true;
  if (stop.waiting > 0 && seatsLeft > 0) return true;
  return state.walkers.some((w) => w.kind === 'board' || w.t < STEP_OFF);
}

/**
 * Advances walkers. Returns boarders who reached the door this tick.
 * Alighters fade out after walking away.
 */
export function advanceWalkers(state: RunState, dt: number): Walker[] {
  const arrived: Walker[] = [];
  state.walkers = state.walkers.filter((walker) => {
    walker.t += dt;
    if (walker.kind === 'board' && walker.t >= WALK_TO_DOOR) {
      arrived.push(walker);
      return false;
    }
    return !(walker.kind === 'alight' && walker.t >= WALK_AWAY);
  });
  return arrived;
}

/** If the driver pulls off mid-boarding, people still walking go back to the crowd. */
export function cancelBoarders(state: RunState): void {
  const walking = boardersWalking(state);
  if (walking === 0) return;
  state.stop.waiting += walking;
  state.walkers = state.walkers.filter((w) => w.kind !== 'board');
}
